module.exports = __webpack_public_path__ + "static/media/energy-web-logo-final.3f4aa376.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/energy-web-logo-final.svg
// module id = 1845
// module chunks = 0